/**
 * Отметка «Выключить на этом устройстве» мобильной версии (specs/006 FR-012; ключ `pushKeys.off`
 * из `src/mobile/services/push.ts`). Устройство одно на обе версии, поэтому полная версия её
 * соблюдает: не подписывает устройство тихо, а «Включить» на её плашке отметку снимает.
 */

export const PUSH_OFF_KEY = "rost.push.off";

/** Push выключен на этом устройстве; хранилище недоступно — не выключен */
export function pushOffHere(): boolean {
    try {
        return localStorage.getItem(PUSH_OFF_KEY) === "1";
    } catch {
        return false;
    }
}

/** «Включить»: отметка выключения снимается */
export function clearPushOff(): void {
    try {
        localStorage.removeItem(PUSH_OFF_KEY);
    } catch {
        // хранилище недоступно — отметки нет
    }
}
